// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TextMessage } from "../../../data/messaging/text-message";
import { EnvelopeDocument } from "../base/envelope-document";

export class TextMessageDocument extends EnvelopeDocument {
	public override Item: TextMessage = new TextMessage();
}